import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";

import ListView from "../../utils/commonComponent/Custom/listView";
import ReportToolbar from "../../utils/commonComponent/reportToolbar";
import { getPermissions } from "../rbac/hasAccess";
import { Autocomplete, TextField } from "@mui/material";
import NABLHeader from "../image/Nabl_Header.png";
import NONABLHeader from "../image/NON_NABL_header.png";
import Footer from "../image/footer.png";
import LoaderModal from "../../utils/loader.js/loader";
import AttendanceExcelReport from "./attendanceExcelReport";
import { weekOffs } from "../leave/applyLeave";
import moment from "moment";

const headers = [
  "id",
  "employeeName",
  "employeesCode",
  "checkinDatetime",
  "checkinPhotoPath",
  "checkinLat",
  "checkinLang",
  "checkoutDatetime",
  "checkoutPhoto",
  "checkoutLat",
  "checkoutLang",
];

const ignoreHeaders = ["checkinPhotoPath", "checkoutPhoto"];

let config = {
  margin: 15,
  borderMagin: 7,
  headerImgHeight: 70,
  headerTableHeight: 25,
  headerTitleHeight: 15,
  footerImgHeight: 70,
  footerTableHeight: 50,
  fontSize: 9,
  cusotmerHeight: 50,
  bordergap: 5,
  currentY: 0,
  footerTotalHeight: 70 + 50,
};

const AttendanceList = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);

  const handleDelete = (row) => submitSiteDelete("attendance", row.id);

  const [attendanceList, setInspectorList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [attendanceRegularizationList, setAttendanceRegularizationList] = useState([]);
  const [leaveManagementList, setLeaveManagementList] = useState([]);
  const [searched, setSearched] = React.useState(false);
  const [inputStates, setInputStates] = React.useState({});
  const [letterHead, setLetterHead] = React.useState(true);
  const [loading, setLoading] = useState(false);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
    setSearched(false);
  };



// 🔹 WHERE clause builder
const getWhereClause = () => {
  const conditions = ["a.status = 1"]; // always active

  const { fromDate, toDate, department, branch } = inputStates || {};

  // 🧩 Report Type Filters
  if (inputStates?.reportTypeId) {
    const today = moment().format("YYYY-MM-DD");

    const reportFilters = {
      2: `DATE(a.checkinDatetime) = '${today}'`,
      3: `TIME(a.checkinDatetime) > '09:30:00'`,
      4: `TIME(a.checkoutDatetime) < '18:30:00'`,
    };

    if (reportFilters[inputStates.reportTypeId]) {
      conditions.push(`(${reportFilters[inputStates.reportTypeId]})`);
    }
  }

  // 📅 Date Filters (FIXED VERSION)
  if (fromDate && toDate) {
    const fromFormatted = moment(fromDate)
      .format("YYYY-MM-DD HH:mm:ss");

    const toFormatted = moment(toDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    conditions.push(
      `a.checkinDatetime BETWEEN '${fromFormatted}' AND '${toFormatted}'`
    );
  } else {
    if (fromDate) {
      const fromFormatted = moment(fromDate)
        .format("YYYY-MM-DD HH:mm:ss");

      conditions.push(`a.checkinDatetime >= '${fromFormatted}'`);
    }

    if (toDate) {
      const toFormatted = moment(toDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      conditions.push(`a.checkinDatetime <= '${toFormatted}'`);
    }
  }

  // 👤 Multiple employee filter
  if (inputStates?.employeeIds?.length) {
    conditions.push(
      `a.employeeId IN (${inputStates.employeeIds.join(",")})`
    );
  }

  // 🏢 Department filter
  if (department) {
    conditions.push(`eod.department = '${department}'`);
  }

  // 🏬 Branch filter
  if (branch) {
    conditions.push(`eod.branchId = '${branch}'`);
  }

  // 👤 User-type restriction
  if (![1, 2, 8].includes(_userType)) {
    conditions.push(`a.employeeId = ${_employeeId}`);
  }

  return `WHERE ${conditions.join(" AND ")}`;
};

  // 🔹 DATA query
  const getDataQuery = () => {
    const whereClause = getWhereClause();

    return `
    SELECT
      a.id,
      a.userId,
      a.employeeId,
      a.addressId,
      a.checkinDatetime,
      a.checkinPhotoPath,
      a.checkinLat,
      a.checkinLang,
      a.checkoutDatetime,
      a.checkoutPhoto,
      a.checkoutLat,
      a.checkoutLang,
      a.status,

      e.employeesCode AS employeesCode,
      e.name AS employeeName,

      -- 🔹 employeeOtherData fields
      eod.branchId AS branch,
      eod.department,
      eod.hrDesignation AS designation

    FROM attendance a
    LEFT JOIN employees e 
      ON a.employeeId = e.id

    LEFT JOIN employeeOtherData eod 
      ON a.employeeId = eod.employeeId

    ${whereClause}
    ORDER BY a.id DESC;
  `;
  };

  // 🔹 Fetch data
  const fetchData = async () => {
    try {
      const [attendanceData] = await Promise.all([fetchQuery(getDataQuery())]);

      setInspectorList(attendanceData);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  function addHeaderFooter(doc) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const headers = {
      1: NABLHeader,
      2: NONABLHeader,
    };
    const headerImage = NABLHeader;
    doc.addImage(headerImage, "PNG", 0, 0, pageWidth, config?.headerImgHeight);
    doc.addImage(
      Footer,
      "PNG",
      0,
      pageHeight - config?.footerImgHeight,
      pageWidth,
      config?.footerImgHeight
    );
  }

  const generateLeaveReport = ({ attendanceList, headers, letterHead }) => {
    try {
      // setLoading(true);

      requestAnimationFrame(() => {
        const doc = new jsPDF({
          orientation: "p",
          unit: "pt",
          format: "a4",
          compress: true,
        });

        // Format headers
        // Format headers, skipping ignored ones
        const formattedHeaders = headers
          .filter((h) => !ignoreHeaders.includes(h))
          .map((h) =>
            h === "id"
              ? "Sr. No"
              : h
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (s) => s.toUpperCase())
          );

        // Prepare rows, skipping ignored headers
        const tableRows = attendanceList.map((row, index) =>
          headers
            .filter((key) => !ignoreHeaders.includes(key))
            .map((key) => {
              if (key === "id") return index + 1;

              let value = row[key] ?? "";

              if (
                ["checkoutDatetime", "checkinDatetime"].includes(key) &&
                value
              ) {
                const d = new Date(value);
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                let h = d.getHours();
                const m = String(d.getMinutes()).padStart(2, "0");
                const ampm = h >= 12 ? "PM" : "AM";
                h = h % 12 || 12;
                value = `${day}-${month}-${year} ${h}:${m} ${ampm}`;
              }

              return value;
            })
        );

        // Draw table with header/footer
        autoTable(doc, {
          head: [formattedHeaders],
          body: tableRows,
          startY:
            config.headerImgHeight +
            config.headerTableHeight +
            config.headerTitleHeight +
            config.borderMagin,
          styles: {
            fontSize: config.fontSize,
            cellPadding: 4,
            fillColor: null,
            lineWidth: 0.5,
            lineColor: 0,
          },
          headStyles: {
            fillColor: null,
            textColor: 0,
            halign: "center",
          },
          bodyStyles: {
            fillColor: null,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: null,
          },
          margin: { left: config.margin, right: config.margin },
          didDrawPage: () => {
            if (letterHead) addHeaderFooter(doc);
          },
        });

        doc.save("Attendance-Report.pdf");
        setLoading(false);
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setInputStates({});
  };

  // ================= HOLIDAY =================
  const fetchHolidays = async () => {
    try {
      const holidays = await fetchQuery(`
        SELECT date
        FROM holidayRegister
        WHERE status = 1
      `);
      setHolidayList(holidays || []);
    } catch (err) {
      console.error("Holiday error", err);
    }
  };

  // ================= ATTENDANCE REGULARIZATION =================
  const fetchPendingAttendanceRegularization = async () => {
    try {
      const data = await fetchQuery(`
      SELECT ar.*, um.employeeId
      FROM attendanceRegularization ar
      LEFT JOIN userMaster um ON ar.userId = um.id
      WHERE ar.approveStatus = 0
    `);
      setAttendanceRegularizationList(data || []);
    } catch (err) {
      console.error("Attendance Regularization error", err);
    }
  };

  // ================= LEAVE MANAGEMENT =================
const fetchApprovedLeaveManagement = async () => {
  try {
    const data = await fetchQuery(`SELECT fromDate, toDate, fromLeaveValue, toLeaveValue, leaveType, approveLevel2, employeeId FROM leaveManagement WHERE approveLevel2 = 2 AND status = 1`);

    setLeaveManagementList(data ?? []);
  } catch (error) {
    console.error("Leave Management error:", error);
    setLeaveManagementList([]);
  }
};


  useEffect(() => {
    fetchHolidays();
    fetchPendingAttendanceRegularization();
    fetchApprovedLeaveManagement();
  }, []);

  return (
    <>
      <ReportToolbar
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        searched={searched}
        handleSearch={handleSearch}
        clearSearch={clearSearch}
        permissions={permissions}
      />

      {(permissions.pdfDownload || permissions.allAccess) && (
        <>
          <br />
          <br />
          <div
            className="mb-5"
            style={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: "19px", // ✅ exact horizontal gap
              rowGap: "19px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                flex: "0 0 auto", // ✅ prevent stretching
                display: "flex",
                alignItems: "center",
              }}
            >
              <AddButton
                label="Download PDF"
                id="quotation_view_generatepdf"
                onClick={() => {
                  setLoading(true);
                  requestAnimationFrame(() => {
                    generateLeaveReport({
                      attendanceList,
                      headers,
                      letterHead,
                    });
                  });
                }}
              />
            </div>

            <div style={{ flex: "0 0 auto" }}>
              <AttendanceExcelReport
                attendanceList={attendanceList}
                weekOffs={weekOffs}
                holidayList={holidayList}
                attendanceRegularizationList={attendanceRegularizationList}
                leaveManagementList={leaveManagementList}
              />
            </div>
          </div>
        </>
      )}

      <ListView
        headers={headers}
        data={attendanceList}
        actions={{
          //   edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"attendance"}
        rowsPerPageOptions={[-1]}
        moduleId={props.moduleId}
        totalRows={attendanceList?.length}
      />

      <LoaderModal loading={loading} />
    </>
  );
};

export default AttendanceList;
